/* eslint-disable */
/* eslint-disable prefer-template */
import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { compose } from 'redux';
import { createStructuredSelector } from 'reselect';
import styled from 'styled-components';
import { Button } from '../../../components/Buttons';
import { Camera, Check, IsClosed, IsOpen, Left, Plus, CircleTimes, View, Times, EditSquare } from '../../../components/Icon';
import { Loader } from '../../../components/Loader';
import { selectWork, selectWorks } from '../../Api/selectors';
import { performAction } from '../actions';
import {
  EXTERIOR_ATTENTION_OPTIONS_IDW,
  INTERIOR_ATTENTION_OPTIONS_IDW,
  TECHNICAL_ATTENTION_OPTIONS_IDW,
} from '../constants';
import { PerformActionButton } from './PerformActionButton';
import { BaseCellComp } from './BaseCellComp';
import { HBox, VBox } from '../../../components/Box';
import { selectAllOptions, selectVehicle } from '../../Vehicles/selectors';

import {
  addVehicleOption,
  deleteVehicleProperty,
  fetchVehicle,
  removeVehicleOption,
  setVehicleProperty,
} from '../../Vehicles/actions';
import { ButtonBar } from '../../../components/ButtonBar';
import _ from 'lodash';
import {
  REQUEST_VEHICLE,
  REQUEST_VEHICLE_PROPERTY_UPDATE,
  SET_VEHICLE_LOCATION,
  WS2_1_IMPRESSION_PHOTOS,
  WS2_1_GENERAL_PHOTOS,
  WS2_1_IMPORT_PHOTOS_COMMERCIAL,
  WS2_1_IMPORT_PHOTOS_PASSENGER,
  WS2_1_TESLA_ADDITIONAL_PHOTOS,
  WS2_1_EXTRA_PHOTO_NEW,
} from '../../Vehicles/constants';
import { COLOR_BG_LIGHT, COLOR_PRIMARY_1, COLOR_SECONDARY_1 } from '../../../vars';
import { FormField } from '../../../components/FormFields';
import { addDocument, addMultipleDocs, deleteDocument } from '../../Documents/actions';
import DatePicker from 'react-datepicker';
import dayjs from 'dayjs';
import { parseISO } from 'date-fns';
import { VehiclePropertyLoadable } from '../../Vehicles/components/VehiclePropertyLoadable';
import { WithVehicle } from '../../Vehicles/components/WithVehicle';
import customParseFormat from 'dayjs/plugin/customParseFormat';

import { Dropdown } from 'bootstrap';

import { Cell as ActionCell } from './Cell';
import { resizeAndRotate } from '../../../utils/image';
import { getPropByName } from '../../../utils/props';
import { getVehicleAge } from '../../Vehicles/helpers';
import {
  optionsList_inspection,
  optionsList_inspectionPart1,
  optionsList_inspectionPart2,
  optionsList_inspectionPart3,
  optionsList_inspectionPart4,
  optionsList_inspectionPart5,
  clientId,
} from '../../../env';
import { selectUser } from '../../Users/selectors';
import { VehicleLocationCard } from '../../Vehicles/components/VehicleLocationCard';
import { SearchSelect } from '../../../components/SearchSelect';
import { REQUEST_ADD_DOCUMENT } from '../../Companies/constants';
import { REQUEST_ADD_MULTIPLE_DOCUMENTS, REQUEST_DELETE_DOCUMENT } from '../../Users/constants';
import styles from './Interior_inspection_mobile_page.module.css';
import cn from 'classnames';
import ButtonComponent from '../../../containers/App/Components/Button/Button';
import ModalComponent from '../../../containers/App/Components/Modal/Modal';
import CheckboxComponent from '../../../containers/App/Components/Checkbox/Checkbox';
import { AddPhotoButton } from '../../../components/AddPhotoButton';
import { RegplateLabel } from '../../Vehicles/components/RegplateLabel';
import { CarExteriorIncidentsInteractive } from '../../Vehicles/components/InteractiveExteriorIncidents';
import { AppClientId } from '../../Shared/constants';
import { Cell, List, Row } from '../../../components/List';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheckCircle, faTimesCircle } from '@fortawesome/free-regular-svg-icons';
import { VehicleCopyOptionsModal } from '../../Vehicles/components/CopyOptionsModal';
import { Input } from '../../../components/Input';
import { CompanyLabelById } from '../../Companies/components/CompanyLabelById';
import { UserLabelById } from '../../Users/components/UserLabelById';
import { isMobileDevice } from '../../../utils/checkDevice';

dayjs.extend(customParseFormat);

const Container = styled.div`
  .modal-inner {
  }

  .custom-select .Select-control {
    font-size: 16px !important; /* Adjust as needed */
  }
  .option {
    &.inactive {
      opacity: 0.5;
    }
  }

  .grid-container {
    width: 100%;
    display: grid;
    grid-template-columns: 49% 49%;

    .cell {
      margin: 5px;
      background-color: ${COLOR_BG_LIGHT};
      color: #808185;
      font-weight: 600;
      text-align: center;
      padding: 10px 0;
      border-radius: 0.375rem;
      box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, 0.075);
    }
  }

  .import-photo-wrapper {
    justify-content: space-between;
    height: 100%;
  }
  .pane {
    border-top: 1px solid #eee;
    padding: 12px 0;
    border-bottom: 1px solid #eee;
    width: 100%;
    margin-bottom: 12px;
    border-bottom: none;

    .title {
      text-transform: uppercase;
    }
    h1 {
      font-size: 14px;
      font-weight: 400;
    }
  }

  .optionPhoto {
    position: fixed;
    background-color: black;
    z-index: 9999;

    .img {
      position: absolute;
      top: 90px;
      left: 10px;
      right: 10px;
      bottom: 10px;
      background-size: contain;
      background-position: center center;
    }
  }
  .options-list {
    .title {
      font-weight: 400;
      font-size: 14px !important;
      margin-top: 12px;
      font-size: 1.2rem;
      border-bottom: 1px solid #ddd;
      width: 100%;
      margin-bottom: 3px;
    }
    font-weight: 400;
  }
  .image-available {
    width: 32px;
    height: 32px;
    background-color: ${COLOR_SECONDARY_1};
    color: white;
    border-radius: 15px;
    text-align: center;
    margin-right: 3px;
    padding-top: 1px;

    .icon {
      margin: 0;
      padding: 0 0;
    }
  }

  .manco-list > div {
    margin: 12px 0;
  }

  .loadable-block {
    min-width: 100%;
    max-width: 100%;

    .button_triple {
      &.button {
        min-width: 30%;
        max-width: 30%;
      }
    }
  }

  .triple {
    display: flex;
    flex-direction: column;
    gap: 12px;
    margin: 12px 0;

    .btn-check:checked + .btn {
      background-color: var(--color-new-secondary);
      border-color: var(--color-new-secondary);
      color: #fff; /* optioneel: tekst wit voor contrast */
    }
    .btn-check:not(:checked) + .btn {
      border-color: var(--color-new-primary);
      color: var(--color-new-primary);
    }

    transition: opacity 0.2s;
    .check {
      transition: opacity 0.2s;
      display: inline-block;
      width: 24px;
      height: 24px;
      border: 1px solid ${COLOR_PRIMARY_1};
      color: ${COLOR_PRIMARY_1};
      text-align: center;
      font-size: 21px;
      line-height: 20px;
    }

    &.triple-0 {
      .check {
      }
    }
    &.triple-1 {
      .check {
        border: 1px solid #3bb78e;
        color: #3bb78e;
      }
    }
    &.triple-2 {
      .check {
        border: 1px solid red;
        text-align: center;
        color: red;
      }
    }

    &.disabled {
      opacity: 0.4;
      .check {
        opacity: 0;
      }
    }
  }

  .tire_set {
    // padding: 12px;
    // background-color: #eee;

    > .box {
      max-width: 330px;
    }
    .tire-depth-container {
      width: 100%;
      .button {
        width: 50px;
        margin: 2px;
        align-self: stretch;
      }
    }

    .vehicle-property-loadable {
      max-width: 300px;
      &.loading {
        opacity: 0.2;
      }
    }
  }

  .attention-img {
    width: 100px;
    height: 100px;
    flex-shrink: 0;
    background-size: contain;
    border: 1px solid black;
    background-position: center center;
    .add {
      width: 100px;
      height: 100px;
    }
  }

  .import-img {
    width: 200px;
    height: 120px;
    flex-shrink: 0;
    background-size: cover;
    background-position: center center;
    .add {
      width: 100px;
      height: 100px;
    }
  }

  .multi-img {
    width: 33%;
    height: 120px;
    flex-shrink: 0;
    background-size: cover;
    background-position: center center;
  }
  .buttons {
    width: 130px;
    .button {
      margin: 0 2px;
    }
  }
`;

const StateToggler = styled.div`
  min-height: 24px;
  width: ${props => (props.small ? '110px' : '160px')};
  border-radius: 12px;
  background-color: ${({ isActive }) => (!!isActive ? 'var(--color-new-secondary)' : '#fa5c7c')};
  color: white;
  font-weight: bold;
  padding: 0 2px;
  display: flex;
  align-items: center;
  margin-left: auto;
  margin-right: 0;
`;
const PhotoWrapper = styled.div`
  width: 36px;
  height: 36px;
  border-radius: 18px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: ${props => (props.isActive ? 'white' : 'grey')};
  background-color: ${props => (props.isActive ? 'var(--color-new-secondary)' : 'var(--color-new-white)')};
`;

const RequireMark = styled.span`
  margin-left: 4 px;
  font-size: 24px;
  color: red;
`;

const STATE = {
  approve: false,
  options: false,
  manco: false,
  attention: false,
  regplate_code: '',
  date_last_maintenance: '',
  mileage_last_maintenance: '',
  date_timing_belt_change: '',
  mileage_timing_belt_change: '',
  mileage: '',
  attentionIncidentCost: '',
  attentIncidentEdit: false,
  attentionIncidentAcceptable: null,
  attentionIncidentCommercial: null,
  inspection_attention_photos_exterior: null,
  inspection_attention_photos_interior: null,
  inspection_attention_photos_technical: null,
  attentionIncidentRepaired: false,
  attentionIncidentShow: true,
  attentionIncidentPhoto: [],
  showCopyOptionsModal: false,
  showCopyPhotosModal: false,
};

/* eslint-disable react/prefer-stateless-function */
class Interior_inspection_mobile_pageComp extends BaseCellComp {
  constructor(props) {
    super(props, { ...STATE });
  }

  componentDidMount() {
    const comments = this.vehicle?.properties
      ?.filter(p => p?.propertyName?.name?.startsWith('attention_comment_'))
      ?.reduce(
        (acc, prop) => ({
          ...acc,
          [prop?.propertyName?.name]: prop?.propertyValue?.value,
        }),
        {},
      );
    this.setState({
      ...comments,
      mileage: getPropByName(this.vehicle, 'mileage'),
      vin: this.vehicle?.vin,
      regplate: this.vehicle?.regplate,
      mileage: this.vehicle?.mileage,
    });
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevProps.vehicle != this.props.vehicle) {
      const comments = this.vehicle?.properties
        ?.filter(p => p?.propertyName?.name?.startsWith('attention_comment_'))
        ?.reduce(
          (acc, prop) => ({
            ...acc,
            [prop?.propertyName?.name]: prop?.propertyValue?.value,
          }),
          {},
        );
      this.setState({
        ...comments,
        mileage: getPropByName(this.vehicle, 'mileage'),
        vin: this.vehicle?.vin,
        regplate: this.vehicle?.regplate,
        mileage: this.vehicle?.mileage,
      });
    }
  }

  closeBootstrapDropdown(e) {
    const dropdownElement = e.target.closest('.dropdown');
    const bsDropdown = Dropdown.getInstance(dropdownElement) || new Dropdown(dropdownElement);
    bsDropdown.hide();
  }

  reset() {
    console.log('History Object:', this.props.history); // Debug log
    this.setState({ ...STATE });
    this.props.history.push(`/vehicles/${this.vehicle.id}`); // Redirect to the specific vehicle page
  }

  get initPanesArray() {
    const initialPanes = {
      // inspection: false,
      // ['vehicle-details']: false,
      // options: false,
      // manco: false,
      // attention: false,
      // interior_inspection: false,
      // technical_inspection: false,
      // import_photo: false,
      // impression: false,
    };

    return initialPanes;
  }

  get numKeysPhotoInterior() {
    let photo = this.vehicle.documents?.find(document => document.type == 'photo_interior_num_keys');

    return photo;
  }

  static getDerivedStateFromProps(props, state) {
    ['mileage_last_maintenance', 'mileage_timing_belt_change'].map(name => {
      let val = props.cell?.vehicle[name];
      if (val) {
        if (val.updatedAt != state[name + '_updatedAt']) {
          state[name + '_updatedAt'] = val.updatedAt;
          state[name] = val.propertyValue.value;
        }
      } else {
      }
    });
    return state;
  }

  confirm() {
    this.props.confirm(this.vehicle.id, this.state.regplate_code);
  }

  propertyValue(name) {
    return this.vehicle[name];
  }

  get vehicle() {
    return this.props.vehicle;
  }

  get userData() {
    return `${getPropByName(this.props.loggedInUser, 'name') || ''} ${getPropByName(this.props.loggedInUser, 'surname') ||
      ''}`;
  }

  multiPhotosDto(incidentId) {
    let initialDto = {
      files: [],
      docs: [],
      entities: [{ entitiId: this.props.vehicle?.id, entitiType: 'vehicle' }],
    };

    let dto = this.state.attentionIncidentPhoto?.reduce((acc, curr) => {
      acc.files?.push(curr.file);
      acc.docs?.push({
        name: `inspection_incident_${incidentId}`,
        type: `photo_interior_inspection_incident_${incidentId}`,
        originalFilename: 'originalFilename',
      });
      return acc;
    }, initialDto);

    return dto;
  }

  editVehicle() {
    ['regplate', 'vin', 'mileage'].map(prop => {
      if (this.state[prop]) {
        return this.props.setProperty(prop, this.state[prop]);
      }
    });
  }

  renderVehicleDescription() {
    return (
      <>
        <div>
          <RegplateLabel regplate={this.vehicle?.regplate} width="80" />
        </div>
        <div>
          <h3>
            {this.vehicle.brand_name} {this.vehicle.model_name}
          </h3>
        </div>
        <div>
          <div>{this.vehicle?.model_info}</div>
        </div>
      </>
    );
  }

  renderEditableVehicleFields() {
    return (
      <VBox>
        {['regplate', 'vin'].map(prop => {
          return (
            <HBox key={prop} vCenter>
              {this.lbl(`vehicle.property.${prop}`)}

              <HBox style={{ width: '50%', marginBottom: '8px' }}>
                <VehiclePropertyLoadable name={prop}>
                  <input
                    className="form-control"
                    type={prop}
                    value={this.state[prop]}
                    onChange={this.onInputChange.bind(this)}
                    name={prop}
                    key={prop}
                    onBlur={() => {
                      this.state[prop] && this.props.setProperty(prop, this.state[prop]);
                      console.log('onBlur', this.state[prop]);
                    }}
                  />
                </VehiclePropertyLoadable>
              </HBox>
            </HBox>
          );
        })}
        <List>
          <Row>
            <Cell>{this.lbl(`vehicle.property.creditor_company`)}</Cell>
            <Cell>
              <CompanyLabelById company_id={this.vehicle.creditor_company} />
            </Cell>
          </Row>

          <Row>
            <Cell>{this.lbl(`vehicle.property.buying_company`)}</Cell>
            <Cell>
              <CompanyLabelById company_id={this.vehicle.buying_company} />
            </Cell>
          </Row>

          <Row>
            <Cell>{this.lbl(`vehicle.property.buying_contact`)}</Cell>
            <Cell>
              <UserLabelById user_id={this.vehicle.buying_contact} />
            </Cell>
          </Row>
        </List>
        {this.props.workLocation || this.props.workVehicle ? (
          <Loader small />
        ) : (
          ['location'].map(prop => {
            return <VehicleLocationCard vehicle={this.vehicle} kanbanActionPage />;
          })
        )}
      </VBox>
    );
  }

  requiredOption() {
    const reqProps = ['warranty_sticker'];
    const isReq = this.tripleCheckProps?.filter(type => reqProps?.includes(type));

    return isReq;
  }

  applyDisabled() {
    const missingItems = [];

    // Check required triple check properties
    this.tripleCheckProps?.forEach(type => {
      if (this.requiredOption()?.includes(type) && this.vehicle[type] === 0) {
        missingItems.push(`Required option: ${type}`);
      }
    });

    // Ensure at least one tire set exists
    const tireSetsExist = _.some(_.times(10), i => !!this.propertyValue(`tire_set_${i}`));

    if (!tireSetsExist) {
      missingItems.push('Banden set');
    }

    // Required photos
    const requiredPhotos = [
      // 'impression_left_front',
      // 'impression_right_front',
      // 'impression_right_back',
      // 'impression_left_back',
      // 'impression_interior_full',
      // 'impression_mileage',
      // 'impression_interior_side',
      // 'impression_keys_instruction',
    ];
    let photoMissingAdded = false;
    requiredPhotos.forEach(photo => {
      const photoUploaded = this.vehicle.documents?.some(doc => doc.type === `photo_interior_import_0 ${photo}`);
      if (!photoUploaded && !photoMissingAdded) {
        missingItems.push(`Niet alle foto's zijn toegevoegd`);
        photoMissingAdded = true; // Set flag to true after adding the message
      }
    });

    // Check if VIN, mileage, and num_keys are set
    if (!this.vehicle?.vin) {
      missingItems.push('VIN');
    }
    if (!this.vehicle?.mileage) {
      missingItems.push('KM-stand');
    }
    if (!this.vehicle?.num_keys) {
      missingItems.push('Aantal sleutels');
    }

    // Store missing items for the alert and disable the button if any are missing
    this.missingItems = missingItems;
    return missingItems.length > 0;
  }

  capture(name, callback, setToLocalState) {
    //remove existing image upload
    document.getElementById('image-upload')?.remove();

    let input = document.createElement('input');
    input.type = 'file';
    input.name = 'image';
    input.id = 'image-upload';
    input.accept = 'image/*';

    if (isMobileDevice()) {
      input.setAttribute('capture', 'environment');
    }

    document.body.appendChild(input);

    input.click();

    let photoType = 'photo_interior_' + name;

    if (name.includes('photo_option')) {
      photoType = name;
    }

    input.addEventListener(
      'change',
      this.callback(evt => {
        resizeAndRotate(evt.target.files[0]).then(file => {
          setToLocalState
            ? this.setState(prev => ({
                attentionIncidentPhoto: [
                  ...prev.attentionIncidentPhoto,
                  {
                    id: Date.now(),
                    name,
                    type: photoType,
                    originalFilename: 'originalFilename',
                    file: file,
                    url: URL.createObjectURL(evt.target.files[0]),
                  },
                ],
              }))
            : this.props.imageUpload(
                {
                  name,
                  type: photoType,
                  originalFilename: 'originalFilename',
                  file,
                },
                'upload_' + name,
              );

          callback?.();

          try {
            evt.target.removeEventListener(evt.target, this._evtListener);
            evt.target.remove();
          } catch (e) {}
        });
      }),
    );
  }

  toggleOption(id, state) {
    this._lastOption = id;

    //todo: busy_ ... is depricated
    this.setState(
      { [`busy_${id}`]: true },
      this.props.toggleOption(id, state, result => {
        this.setState({ [`busy_${id}`]: false });
      }),
    );
  }

  renderPane(name, title, content) {
    return (
      <div className="pane">
        <HBox vCenter className="title" onClick={this.setStateFn({ ...this.initPanesArray, [name]: !this.state[name] })}>
          {title}
          {name !== 'inspection' && <div>{this.state[name] ? <IsOpen /> : <IsClosed />} </div>}
        </HBox>
        {this.state[name] ? content : null}
      </div>
    );
  }

  renderFormField(name, type) {
    let ISO;
    if (type == 'date') {
      let date = this.vehicle[name];
      try {
        ISO = date ? parseISO(dayjs(date, 'DD-MM-YYYY').format('YYYY-MM-DD')) : null;
        if (ISO == 'Invalid Date') ISO = null;
      } catch (error) {
        debugger;
      }
    }
    return (
      <div key={name}>
        <label className="form-label">{this.lbl('vehicle.property.' + name)}</label>

        <VehiclePropertyLoadable name={name}>
          {type == 'date' ? (
            <DatePicker
              className={styles.datePicker}
              dateFormat="dd-MM-yyyy"
              selected={this.vehicle[name] ? ISO : ''}
              onChange={val => {
                val = dayjs(val).format('DD-MM-YYYY');
                this.props.setProperty(name, val);
              }}
            />
          ) : (
            <input
              className="form-control"
              type={type}
              value={this.state[name]}
              onChange={this.onInputChange.bind(this)}
              name={name}
              key={name}
              onBlur={() => {
                this.props.setProperty(name, this.state[name]);
              }}
            />
          )}
        </VehiclePropertyLoadable>
      </div>
    );
  }

  renderOption(value, index) {
    if (value.title)
      return (
        <div className="title" key={index}>
          {this.lbl(`vehicle.options.${value.title}`)}
        </div>
      );

    let option = this.props.allOptions?.find(o => o.name.toLowerCase() == value.toLowerCase());

    let vehicleHasOption = this.vehicle.options?.find(
      o =>
        (typeof o?.name === 'string' ? o?.name.toLowerCase() : '') ===
          (typeof value === 'string' ? value.toLowerCase() : '') && !!o?.VehicleHasOption?.isSelected,
    );

    let checked_name = `checked_${value}`;

    let checked = this.state[checked_name] || vehicleHasOption;
    let photo = this.vehicle.documents?.find(document => document.type == 'photo_interior_' + value);

    let name = `vehicle-option-${option?.id}`;

    return (
      <HBox vCenter key={index} className={`option ${!option ? 'inactive' : ''} option-${option?.id}`}>
        <div className={styles.checkboxContainer}>
          <VehiclePropertyLoadable name={name}>
            <CheckboxComponent
              label={value}
              checked={checked}
              onChange={option ? () => this.toggleOption(option.id, !checked) : null}
            />
          </VehiclePropertyLoadable>
        </div>
        <VehiclePropertyLoadable name={`upload_${value}`}>
          {photo ? (
            <div
              className="pointer image-available"
              onClick={() => {
                let container = document.getElementsByClassName('modal-inner')[0];
                let renderOptionPhotoDims = container.getBoundingClientRect();
                this.setState({
                  renderOptionPhoto: photo.id,
                  renderOptionPhotoDims,
                });
              }}
            >
              <Camera />
            </div>
          ) : (
            <div onClick={this.setStateFn({ optionPhoto: option?.id })} className={cn('pointer', styles.buttonCamera)}>
              <Camera
                className={styles.icon}
                onClick={() =>
                  this.capture(
                    value,

                    this.callback(() => this.props.toggleOption(option.id, true)),
                  )
                }
              />
            </div>
          )}
        </VehiclePropertyLoadable>
      </HBox>
    );
  }

  handlePhotoDelete = (documentId, isFromState) => {
    if (confirm()) {
      if (isFromState) {
        this.setState(prev => ({
          renderOptionPhoto: null,
          attentionIncidentPhoto: prev.attentionIncidentPhoto?.filter(p => {
            return p.id !== documentId;
          }),
        }));
        return;
      }
      const group = this.vehicle.documents?.find(d => d.id === documentId)?.type;
      if (this.vehicle.documents?.filter(d => d?.type === group)?.length === 1) {
        const index = group?.slice(25);
        this.setState({ [`attention_comment_${index}`]: '' });
        this.props.deleteProperty(`attention_comment_${index}`);
        this.props.deleteProperty(`attention_repaired_${index}`);
        this.props.deleteProperty(`attention_displayed_${index}`);
      }
      this.props.deleteDocument(documentId, this.setStateFn({ renderOptionPhoto: null }));
    }
  };

  renderOptionPhoto() {
    if (!this.state.renderOptionPhoto) return null;

    if (this.props.workDoc || this.props.workUpdate) return <Loader small />;

    let document = this.vehicle.documents?.find(document => document.id == this.state.renderOptionPhoto);

    if (!document) {
      document = this.state.attentionIncidentPhoto?.find(photo => photo?.name == this.state.renderOptionPhoto);
    }
    const isFromStateDoc = document?.name == this.state.renderOptionPhoto;

    const documentId = isFromStateDoc ? document?.id : document?.id;

    return (
      <div
        onClick={this.setStateFn({ renderOptionPhoto: null })}
        className="optionPhoto"
        // style={{
        //   width: Math.ceil(this.state.renderOptionPhotoDims.width) + 'px',
        //   height: window.innerWidth <= 768 ? '100%' : Math.ceil(this.state.renderOptionPhotoDims.height) + 'px',
        //   left: Math.ceil(this.state.renderOptionPhotoDims.x) + 'px',
        //   top: window.innerWidth <= 768 ? '70px' : Math.ceil(this.state.renderOptionPhotoDims.y) + 'px',
        // }}
        style={{
          width: Math.ceil(this.state.renderOptionPhotoDims.width) + 'px',
          height: '100%',
          left: Math.ceil(this.state.renderOptionPhotoDims.x) + 'px',
          top: 0,
        }}
      >
        <div
          className="img"
          style={{ backgroundImage: `url('${encodeURI(decodeURI(document.url)).replace(/%5C/g, '/')}')` }}
        ></div>
        <HBox>
          <Button onClick={this.setStateFn({ renderOptionPhoto: null })}>
            <Left /> {this.lbl('back')}
          </Button>
          <Button
            onClick={() => {
              if (
                (this.state.attentIncidentAdd || this.state.attentIncidentEdit) &&
                this.state.currentAttentionType !== 'technical' &&
                this.state.disableDeletePhoto
              ) {
                alert('The incident must include at least one photo');
                return;
              }
              this.handlePhotoDelete(documentId, isFromStateDoc);
            }}
          >
            {' '}
            <Times />
            {this.lbl('delete')}
          </Button>
        </HBox>
      </div>
    );
  }

  renderNewPhoto(option) {
    const v = this.props.vehicle;
    let photoIndex = option == 'generalPhotos' ? 'photo_interior_general_0' : 'photo_interior_import_0';

    if (!v) return null;
    if (!this.state.mileage) {
      this.setState({ mileage: getPropByName(v, 'mileage') });
    }
    const vehiclePurpose = getPropByName(this.vehicle, 'vehicle_purpose');
    let extraPhotos = [];
    let defaults = [];
    let rows = [];

    defaults = WS2_1_EXTRA_PHOTO_NEW;

    defaults?.map((type, i) => {
      let photos = v.documents?.filter(d => {
        return d?.type?.indexOf(`${photoIndex} ${type}`) === 0;
      });

      return rows.push({
        index: i,
        placeholder: type,
        photos,
      });
    });

    return (
      <>
        <div key="import_photos" className="grid-container">
          {rows.map(row => {
            return (
              <div key={row?.placeholder}>
                <div className="cell">
                  {row?.photos?.length > 0 ? (
                    <VBox center className="import-photo-wrapper">
                      {row?.photos?.map(doc => this.renderImportPhoto(doc))}
                      <span>{this.lbl(`vehicle.import_photos.${row?.placeholder}`)}</span>
                    </VBox>
                  ) : (
                    <VBox
                      center
                      className="import-photo-wrapper"
                      onClick={() => {
                        this.addImportImage(0, row.placeholder, option);
                      }}
                    >
                      {this.renderPlaceholderImage(vehiclePurpose, row?.placeholder, option)}
                      <span>{this.lbl(`vehicle.import_photos.${row?.placeholder}`)}</span>
                    </VBox>
                  )}
                </div>
              </div>
            );
          })}
          {option == 'generalPhotos' && (
            <div class="cell">
              <HBox
                vCenter
                className="import-photo-wrapper extra-photo-wrapper"
                onClick={() => this.addImportImage(0, `extra_${extraPhotos?.length}`, option)}
              >
                <div style={{ fontSize: '26px' }}>
                  <Plus />
                </div>
              </HBox>
            </div>
          )}
        </div>
      </>
    );
    return null;
  }

  renderImportPhotos(option) {
    const v = this.props.vehicle;
    let photoIndex = option == 'generalPhotos' ? 'photo_interior_general_0' : 'photo_interior_import_0';

    if (!v) return null;
    if (!this.state.mileage) {
      this.setState({ mileage: getPropByName(v, 'mileage') });
    }
    const vehiclePurpose = getPropByName(this.vehicle, 'vehicle_purpose');
    let extraPhotos = [];
    let defaults = [];
    let rows = [];

    if (vehiclePurpose === 'passenger') {
      defaults = WS2_1_IMPORT_PHOTOS_PASSENGER;
    }

    if (vehiclePurpose === 'commercial') {
      defaults = WS2_1_IMPORT_PHOTOS_COMMERCIAL;
    }

    if (option === 'generalPhotos') {
      defaults = WS2_1_GENERAL_PHOTOS;
    }

    if (option === 'tesla_additional_info') {
      defaults = WS2_1_TESLA_ADDITIONAL_PHOTOS;
    }
    defaults?.map((type, i) => {
      let index = `${photoIndex} ${type}`;
      if (type === 'counter_clock') {
        index = 'photo_interior_tellerklok';
      }

      if (type === 'popnagels_1') {
        index = 'photo_option_Betimmering laadruimte';
      }

      if (type === 'popnagels_2') {
        index = 'photo_option_Tussenschot';
      }

      if (type === 'popnagels_3') {
        index = 'photo_option_Kofferruimte';
      }

      let photos = v.documents?.filter(d => {
        return d?.type?.indexOf(index) === 0;
      });

      return rows.push({
        index: i,
        placeholder: type,
        photos,
      });
    });

    if (option == 'generalPhotos') {
      extraPhotos = v.documents?.filter((d, index) => {
        return d.type?.includes(`${photoIndex} extra_`);
      });
      extraPhotos?.map((d, index) => {
        return rows.push({
          placeholder: `extra_${index + 1}`,
          photos: [d],
        });
      });
    }

    return (
      <>
        <div key="import_photos" className="grid-container">
          {rows.map(row => {
            return (
              <div key={row?.placeholder}>
                <div className="cell">
                  {row?.photos?.length > 0 ? (
                    <VBox center className="import-photo-wrapper">
                      {row?.photos?.map(doc => this.renderImportPhoto(doc))}
                      <span>{this.lbl(`vehicle.import_photos.${row?.placeholder}`)}</span>
                    </VBox>
                  ) : (
                    <VBox
                      center
                      className="import-photo-wrapper"
                      onClick={() => {
                        this.addImportImage(0, row.placeholder, option);
                      }}
                    >
                      {this.renderPlaceholderImage(vehiclePurpose, row?.placeholder, option)}
                      <span>{this.lbl(`vehicle.import_photos.${row?.placeholder}`)}</span>
                    </VBox>
                  )}
                </div>
              </div>
            );
          })}
          {option == 'generalPhotos' && (
            <div className="cell">
              <HBox
                vCenter
                className="import-photo-wrapper extra-photo-wrapper justify-content-center"
                onClick={() => this.addImportImage(0, `extra_${extraPhotos?.length}`, option)}
              >
                <div style={{ fontSize: '26px' }}>
                  <Plus />
                </div>
              </HBox>
            </div>
          )}
        </div>
        {/* {!option && (
          <HBox key={'mileage'} vCenter>
            {this.lbl(`vehicle.property.mileage`)}

            <HBox style={{ width: '50%', marginBottom: '8px' }}>
              <VehiclePropertyLoadable name={'mileage'}>
                <input
                  className="form-control"
                  type={'mileage'}
                  value={this.state['mileage']}
                  onChange={this.onInputChange.bind(this)}
                  name={'mileage'}
                  key={'mileage'}
                  onBlur={() => {
                    this.state['mileage'] && this.props.setProperty('mileage', this.state['mileage']);
                    console.log('onBlur', this.state['mileage']);
                  }}
                />
              </VehiclePropertyLoadable>
            </HBox>
          </HBox>
        )} */}
      </>
    );
  }

  renderApprove() {
    return window.innerWidth < 768 ? (
      <WithVehicle loader vehicle_id={this.vehicle.id}>
        {this.renderModalBody()}
      </WithVehicle>
    ) : (
      <ModalComponent
        onClose={this.reset.bind(this)}
        title={
          <>
            {this.props.fullFetch ? (
              <>
                <Loader small />
                &nbsp;
              </>
            ) : null}
            {this.props.action.label}
          </>
        }
      >
        <Container className="modal-inner">
          <WithVehicle loader vehicle_id={this.vehicle.id}>
            {this.showCopyOptionsModal()}
            {this.showCopyPhotosModal()}
            {this.renderModalBody()}
          </WithVehicle>
        </Container>
      </ModalComponent>
    );
  }

  renderTripleCheck(name) {
    let val = this.propertyValue(name);
    let state = val == 1 ? 1 : val == 2 ? 2 : 0;
    let photo = this.vehicle.documents?.find(document => document.type == 'photo_interior_' + name);
    const required = this.requiredOption()?.includes(name) && val == 0;

    return (
      <HBox vCenter key={name}>
        <div
          className={`triple triple-${state} ${this.props.work ? 'disabled' : ''}`}
          // onClick={() => this.props.setProperty(name, state == 0 ? 1 : state == 1 ? 2 : 0)}
        >
          <div className={cn('label', styles.labelCamera)}>{this.lbl(`vehicle.property.${name}`)}</div>
          <VehiclePropertyLoadable name={name}>
            <div className="btn-group" role="group" aria-label="Basic radio toggle button group">
              <input
                type="radio"
                className="btn-check"
                name={`btnradio-${name}`} // uniek per veld
                id={`btnradio1-${name}`}
                autoComplete="off"
                checked={state == 0}
                onChange={() => this.props.setProperty(name, 0)}
              />
              <label className="btn btn-outline-primary" htmlFor={`btnradio1-${name}`}>
                Todo
              </label>

              <input
                type="radio"
                className="btn-check"
                name={`btnradio-${name}`}
                id={`btnradio2-${name}`}
                autoComplete="off"
                checked={state == 1}
                onChange={() => this.props.setProperty(name, 1)}
              />
              <label className="btn btn-outline-primary" htmlFor={`btnradio2-${name}`}>
                Gereed
              </label>

              <input
                type="radio"
                className="btn-check"
                name={`btnradio-${name}`}
                id={`btnradio3-${name}`}
                autoComplete="off"
                checked={state == 2}
                onChange={() => this.props.setProperty(name, 2)}
              />
              <label className="btn btn-outline-primary" htmlFor={`btnradio3-${name}`}>
                Manco
              </label>
            </div>
          </VehiclePropertyLoadable>
          {required && <RequireMark>*</RequireMark>}
        </div>

        {photo ? (
          <div
            className={cn('pointer image-available', styles.buttonCamera)}
            onClick={() => {
              let container = document.getElementsByClassName('modal-inner')[0];
              let renderOptionPhotoDims = container.getBoundingClientRect();
              this.setState({
                renderOptionPhoto: photo.id,
                renderOptionPhotoDims,
              });
            }}
          >
            <Camera />
          </div>
        ) : (
          <div onClick={this.setStateFn({ optionPhoto: name })} className={cn('pointer', styles.buttonCamera)}>
            <VehiclePropertyLoadable name={name}>
              <Camera
                onClick={() =>
                  this.capture(
                    name,
                    this.callback(() => this.props.setProperty(name, 1)),
                  )
                }
              />
            </VehiclePropertyLoadable>
          </div>
        )}
      </HBox>
    );
  }

  get tripleCheckProps() {
    let props = [];
    if (clientId !== AppClientId.INDEWAL) {
      props = [
        'has_instruction_book',
        'has_maintenance_book',
        'has_digital_maintenance',
        'has_headrests',
        'has_hatrest',
        'baggage_cover',
        'has_charge_cable_230v',
        'has_charge_cable_380v',
        'has_charge_port',
        'has_key_lift',
        'has_key_cabinet_fitting',
      ];
    }
    return props;
  }

  get tripleCheckProps1() {
    let props = ['has_instruction_book', 'has_maintenance_book'];

    if (getVehicleAge(this.vehicle?.date_first_allowance) <= 7 && this.vehicle?.brand_name?.toLowerCase() == 'kia') {
      props.push('warranty_sticker');
    }

    return props;
  }

  get tripleCheckProps2() {
    let props = ['has_charge_cable', 'has_headrests', 'bagage_covering'];

    return props;
  }
  get tripleCheckProps3() {
    let props = ['has_key_lift', 'has_key_cabinet_fitting'];

    return props;
  }

  renderTireBlock(n) {
    let name = 'tire_set_' + n;
    let value = this.propertyValue(name);
    if (!value) return null;
    const tireSetDocument = this.vehicle?.documents?.find(doc => {
      return doc.type == 'photo_interior_tires_' + name;
    });

    let values = value.split(':');
    let i = 0;
    let mapped = {
      weather: values[i++],
      material: values[i++],
      size: values[i++],
      lf: values[i++],
      rf: values[i++],
      lb: values[i++],
      rb: values[i++],
      damage: values[i++],
    };

    const setValue = function(tName, tValue) {
      mapped[tName] = tValue;
      let value = '';

      this.props.setProperty(
        name,
        mapped.weather +
          ':' +
          mapped.material +
          ':' +
          mapped.size +
          ':' +
          mapped.lf +
          ':' +
          mapped.rf +
          ':' +
          mapped.lb +
          ':' +
          mapped.rb +
          ':' +
          mapped.damage,
      );
    }.bind(this);

    let tireImage = this.vehicle.documents?.filter(document => document.type?.includes(`photo_exterior_tires_${n}`));
    return (
      <VBox className={`tire_set ${this.props.work ? 'disabled' : ''}`} key={`tire-block-${n}`}>
        <VehiclePropertyLoadable className={'loadable-block'} hideChildrenOnLoad={false} name={name}>
          <label className="form-label">{this.lbl('vehicle.property.tire_set.weather')}</label>
          <div className={cn('d-flex btn-group gap-2 mb-2', styles.buttonGroup)} role="group" aria-label="Basic example">
            {['summer', 'winter', 'all'].map(s => (
              <Button
                className={cn(styles.buttonGroupItem, {
                  [styles.selectedButton]: mapped.weather === s,
                })}
                small={window.innerWidth < 425}
                onClick={() => setValue('weather', s)}
                key={s}
              >
                {this.lbl('vehicle.property.tire_set.weather.' + s)}
              </Button>
            ))}
          </div>
          <label className="form-label">{this.lbl('vehicle.property.tire_set.material')}</label>
          <div className={cn('d-flex btn-group gap-2 mb-2', styles.buttonGroup)} role="group" aria-label="Basic example">
            {['alu', 'steel', 'other'].map(name => (
              <Button
                className={cn(styles.buttonGroupItem, {
                  [styles.selectedButton]: mapped.material == name,
                })}
                small={window.innerWidth < 425}
                onClick={() => setValue('material', name)}
                key={name}
              >
                {this.lbl('vehicle.property.tire_set.material.' + name)}
              </Button>
            ))}
          </div>
          {/* <label className="form-label">{this.lbl('vehicle.property.tire_set.damage')}</label>
          <div className={cn('d-flex btn-group gap-2 mb-2', styles.buttonGroup)} role="group" aria-label="Basic example">
            {['true', 'false'].map(damage => (
              <Button
                className={cn(styles.buttonGroupItem, {
                  [styles.selectedButton]: mapped.damage === damage,
                })}
                small={window.innerWidth < 425}
                onClick={() => setValue('damage', damage)}
                key={damage}
              >
                {this.lbl('vehicle.property.tire_set.damage.' + damage)}
              </Button>
            ))}
          </div> */}

          <label className="form-label">Inch:</label>
          <div className="dropdown">
            <button
              className={cn('btn btn-secondary dropdown-toggle', styles.buttonToggle)}
              type="button"
              id="dropdownMenuButton1"
              data-bs-toggle="dropdown"
              aria-expanded="false"
              role="button"
            >
              {mapped.size}
            </button>
            <ul className="dropdown-menu" aria-labelledby="dropdownMenuButton1">
              {_.times(15, n => (
                <li key={n}>
                  <a
                    disabled={this.props.work}
                    onClick={e => {
                      setValue('size', 12 + n);
                      this.closeBootstrapDropdown(e);
                    }}
                    className="dropdown-item"
                    href="#"
                    role="button"
                    data-bs-toggle="dropdown"
                  >
                    {12 + n}
                  </a>
                </li>
              ))}
            </ul>
          </div>
          <div className={styles.gridContainerTire}>
            {['lf', 'rf', 'lb', 'rb'].map(name => (
              <VBox className="mb-2" key={name}>
                <label className="form-label">{this.lbl('vehicle.property.tire_set.' + name)}</label>
                <div className="dropdown">
                  <button
                    className={cn('btn btn-secondary dropdown-toggle', styles.buttonToggle)}
                    type="button"
                    id="dropdownMenuButton1"
                    data-bs-toggle="dropdown"
                    aria-expanded="false"
                    role="button"
                  >
                    {mapped[name]}
                  </button>
                  <ul className="dropdown-menu" aria-labelledby="dropdownMenuButton1">
                    {_.times(10, n => (
                      <li key={`${name}-${n + 1}`}>
                        <a
                          disabled={this.props.work}
                          onClick={e => {
                            setValue(name, n + 1);
                            this.closeBootstrapDropdown(e);
                          }}
                          className="dropdown-item"
                          href="#"
                          role="button"
                          data-bs-toggle="dropdown"
                        >
                          {n + 1}
                        </a>
                      </li>
                    ))}
                  </ul>
                </div>
              </VBox>
            ))}
          </div>
        </VehiclePropertyLoadable>
        {this.props.workVehicle || this.props.workDoc || this.props.workUpdate ? (
          <Loader small />
        ) : (
          <HBox flexWrap gap={12} className="mb-3">
            {this.vehicle.documents
              .filter(doc => {
                return doc.type == 'photo_interior_tires_' + name;
              })
              .map(doc => {
                return this.renderImportPhoto(doc);
              })}
            {/* <ButtonComponent
              style="ButtonSoftPrimary"
              disabled={
                this.vehicle.documents.filter(doc => {
                  return doc.type == 'photo_interior_tires_' + name;
                })?.length
              }
              onClick={() => {
                this.capture('tires_' + name, this.props.refresh);
              }}
            >
              <Camera />
            </ButtonComponent> */}
          </HBox>
        )}

        <ButtonComponent
          disabled={this.props.workVehicle || this.props.workDoc || this.props.workUpdate}
          style={'ButtonSoftDelete'}
          onClick={() => {
            this.props.deleteProperty(name, () => {
              if (tireSetDocument?.id) {
                this.props.deleteDocument(tireSetDocument?.id);
              }
            });
          }}
        >
          {this.lbl('interior.inspection.tires.remove')}
        </ButtonComponent>
      </VBox>
    );
  }

  addAttentionImage(index, isNewGroup = false) {
    this.capture('attention_' + index);
    if (isNewGroup) {
      this.props.setProperty(`attention_repaired_${index}`, 0);
      this.props.setProperty(`attention_displayed_${index}`, 1);
      this.props.setProperty(`attention_comment_${index}`, '');
    }
  }

  addImportImage(index, type, option) {
    if (option == 'generalPhotos') {
      this.capture('general_' + index + ' ' + type);
    } else {
      let photoType = 'import_' + index + ' ' + type;

      if (type === 'counter_clock') {
        photoType = 'tellerklok';
      }

      if (type === 'popnagels_1') {
        photoType = 'photo_option_Betimmering laadruimte';
      }

      if (type === 'popnagels_2') {
        photoType = 'photo_option_Tussenschot';
      }
      if (type === 'popnagels_3') {
        photoType = 'photo_option_Kofferruimte';
      }

      this.capture(photoType);
    }
  }

  renderImportPhoto(document) {
    return (
      <div key={`import-${document.id}`}>
        <div
          className="import-img"
          onClick={() => {
            let container = window.document.getElementsByClassName('modal-inner')[0];
            let renderOptionPhotoDims = container.getBoundingClientRect();
            this.setState({
              renderOptionPhoto: document.id,
              renderOptionPhotoDims,
            });
          }}
          style={{ opacity: '0.7', backgroundImage: `url('${encodeURI(decodeURI(document.url)).replace(/%5C/g, '/')}')` }}
        ></div>
      </div>
    );
  }

  renderImpressionPhoto(document) {
    return (
      <div key={`impression-${document.id}`}>
        <div
          className="import-img"
          onClick={() => {
            let container = window.document.getElementsByClassName('modal-inner')[0];
            let renderOptionPhotoDims = container.getBoundingClientRect();
            this.setState({
              renderOptionPhoto: document.id,
              renderOptionPhotoDims,
            });
          }}
          style={{ backgroundImage: `url('${encodeURI(decodeURI(document.url)).replace(/%5C/g, '/')}')` }}
        ></div>
      </div>
    );
  }

  renderInspectionProperty(name, hasPhoto = false) {
    let val = this.propertyValue(name);
    let state = val == 1 ? 1 : val == 2 ? 2 : 0;
    let photo = this.vehicle.documents?.find(document => document.type == 'photo_interior_' + name);
    const isOk = state === 1;
    return (
      !!state && (
        <Row className={styles.row} key={name}>
          {this.renderOptionPhoto()}
          <Cell className={styles.cell1}>
            <VBox left>
              {this.lbl(`vehicle.property.${name}`)}
              <strong>{this.vehicle[`${name}_comment`]}</strong>
            </VBox>
          </Cell>
          {!!hasPhoto && (
            <Cell className={styles.cell3}>
              <PhotoWrapper
                isActive={!!photo}
                className={cn('pointer image-available', styles.buttonCameraPhoto)}
                onClick={() => {
                  if (!!photo) this.handleOpenPhoto(photo);
                }}
              >
                <Camera />
              </PhotoWrapper>
            </Cell>
          )}
          <Cell className={styles.cell2}>
            <StateToggler isActive={isOk} small={hasPhoto}>
              <FontAwesomeIcon icon={isOk ? faCheckCircle : faTimesCircle} style={{ width: 22, marginRight: 5 }} />
              {hasPhoto
                ? isOk
                  ? this.lbl('vehicle.inspection.present')
                  : this.lbl('vehicle.inspection.flaw')
                : isOk
                ? this.lbl('vehicle.inspection.checked')
                : this.lbl('vehicle.inspection.failed')}
            </StateToggler>
          </Cell>
        </Row>
      )
    );
  }

  renderPlaceholderImage(vehiclePurpose, type, option) {
    if (option == 'generalPhotos') {
      return (
        <div key={type}>
          <div
            className="import-img"
            style={{
              opacity: '0.4',
              backgroundImage: `url('/public/images/ws2_1_interior_defaults/general/${type}.jpg')`,
            }}
          ></div>
        </div>
      );
    }

    if (option === 'tesla_additional_info') {
      return (
        <div key={type}>
          <div
            className="import-img"
            style={{
              opacity: '0.4',
              backgroundImage: `url('/public/images/ws2_1_interior_defaults/tesla/${type}.png')`,
            }}
          ></div>
        </div>
      );
    }
    return (
      <div key={type}>
        <div
          className="import-img"
          style={{
            opacity: '0.4',
            backgroundImage: `url('/public/images/ws2_1_interior_defaults/${vehiclePurpose}/${type}.png')`,
          }}
        ></div>
      </div>
    );
  }

  showCopyOptionsModal() {
    if (!this.state.showCopyOptionsModal) return;
    return (
      <VehicleCopyOptionsModal vehicleId={this.vehicle?.id} close={() => this.setState({ showCopyOptionsModal: false })} />
    );
  }

  showCopyPhotosModal() {
    if (!this.state.showCopyPhotosModal) return;
    return (
      <VehicleCopyOptionsModal
        copy_photos
        vehicleId={this.vehicle?.id}
        close={() => this.setState({ showCopyPhotosModal: false })}
      />
    );
  }

  renderModalBody() {
    const vehicle = this.vehicle;
    return (
      <div className={cn({ [styles.modalContainer]: window.innerWidth <= 768 })}>
        <VBox key="body" className={cn({ [styles.modalBody]: window.innerWidth <= 768 })}>
          {this.renderOptionPhoto()}
          {this.renderPane('inspection', <div>{this.renderVehicleDescription()}</div>)}
          {this.renderPane(
            'vehicle-details',
            <HBox vCenter>
              <h1>{this.lbl('interior.inspection.vehicle_data')}</h1>
            </HBox>,
            <>{this.renderEditableVehicleFields()}</>,
          )}

          {this.renderPane(
            'testdrive-data',
            <h1>{this.lbl('vehicle.inspection.technical')}</h1>,
            <>
              <List>
                {[
                  'state_engine_general',
                  'state_ac',
                  'state_brakes',
                  'state_transmission',
                  'state_drive',
                  'state_electrics',
                ].map(property => this.renderInspectionProperty(property))}
              </List>
              <br />
            </>,
          )}

          {this.renderPane(
            'options',
            <h1>{this.lbl('interior.inspection.options')}</h1>,
            <VBox className="options-list" key="options">
              <div>
                {' '}
                {clientId === AppClientId.INDEWAL && (
                  <Button small onClick={() => this.setState({ showCopyOptionsModal: true })}>
                    {' '}
                    {this.lbl('vehicle.copy_options')}
                  </Button>
                )}
                {clientId === AppClientId.INDEWAL && (
                  <Button small onClick={() => this.setState({ showCopyPhotosModal: true })}>
                    {' '}
                    {this.lbl('vehicle.copy_photos')}
                  </Button>
                )}
              </div>
              {clientId === AppClientId.INDEWAL ? (
                <>
                  {optionsList_inspectionPart5?.map(this.renderOption.bind(this))}
                  <div className="mb-2 mt-2">
                    {[
                      ['mileage', 'number'],
                      // ['mileage_timing_belt_change', 'number'],
                    ].map(pair => this.renderFormField(pair[0], pair[1]))}
                    <span style={{ color: 'red' }}> * Verplicht veld </span>
                  </div>
                  {optionsList_inspectionPart1?.map(this.renderOption.bind(this))}
                  {this.tripleCheckProps1?.map(name => this.renderTripleCheck(name))}
                  <div className="mb-2 mt-2">
                    {[
                      ['mileage_last_maintenance', 'number'],
                      ['mileage_timing_belt_change', 'number'],
                    ].map(pair => this.renderFormField(pair[0], pair[1]))}
                  </div>
                  {optionsList_inspectionPart2?.map(this.renderOption.bind(this))}
                  {this.tripleCheckProps2?.map(name => this.renderTripleCheck(name))}
                  {vehicle.vehicle_purpose != 'passenger' && optionsList_inspectionPart4?.map(this.renderOption.bind(this))}
                  {optionsList_inspectionPart3?.map(this.renderOption.bind(this))}
                  {vehicle.vehicle_purpose != 'passenger' &&
                    this.tripleCheckProps3?.map(name => this.renderTripleCheck(name))}
                </>
              ) : (
                <>{optionsList_inspection?.map(this.renderOption.bind(this))}</>
              )}
            </VBox>,
          )}
          {this.renderPane(
            'manco',
            <h1>{this.lbl('interior.inspection.onderhoud_banden')}</h1>,
            <VBox className="manco-list" key="manco">
              <div className="w-100">
                {this.lbl('vehicle.property.num_keys')}
                <HBox left vCenter>
                  <VehiclePropertyLoadable name="num_keys">
                    <ButtonBar>
                      {_.times(6, num => {
                        // num += 1;
                        return (
                          <Button
                            key={num}
                            small
                            disabled={this.props.work}
                            primary={num == this.propertyValue('num_keys')}
                            onClick={() => {
                              this.props.setProperty('num_keys', num);
                            }}
                          >
                            {num}
                          </Button>
                        );
                      })}
                    </ButtonBar>
                  </VehiclePropertyLoadable>
                  <HBox right>
                    <VehiclePropertyLoadable name={`upload_num_keys`}>
                      {this.numKeysPhotoInterior?.id ? (
                        <div
                          className="pointer image-available"
                          onClick={() => {
                            let container = document.getElementsByClassName('modal-inner')[0];
                            let renderOptionPhotoDims = container.getBoundingClientRect();
                            this.setState({
                              renderOptionPhoto: this.numKeysPhotoInterior.id,
                              renderOptionPhotoDims,
                            });
                          }}
                        >
                          <Camera />
                        </div>
                      ) : (
                        <div
                          onClick={this.setStateFn({ optionPhoto: this.numKeysPhotoInterior?.id })}
                          className={cn('pointer', styles.buttonCamera)}
                        >
                          <Camera className={styles.icon} onClick={() => this.capture('num_keys')} />
                        </div>
                      )}
                    </VehiclePropertyLoadable>
                  </HBox>
                </HBox>
              </div>
              {this.tripleCheckProps?.map(name => this.renderTripleCheck(name))}
              <div className="title">
                <h1>{this.lbl('interior.inspection.maintenance')}</h1>
              </div>
              {[
                ['mileage_last_maintenance', 'number'],

                ['mileage_timing_belt_change', 'number'],
              ].map(pair => this.renderFormField(pair[0], pair[1]))}
              <div className="title">
                <h1>{this.lbl('interior.inspection.tires')}</h1>
              </div>
              {_.times(10, this.renderTireBlock.bind(this))}

              <ButtonComponent
                disabled={this.props.work}
                onClick={() => {
                  for (let i = 0; i < 10; i++) {
                    if (!this.propertyValue('tire_set_' + i)) {
                      this.props.setProperty('tire_set_' + i, 'summer:alu:11:0:0:0:0');
                      return;
                    }
                  }
                }}
              >
                +
              </ButtonComponent>
            </VBox>,
          )}

          {clientId === AppClientId?.INDEWAL &&
            this.vehicle?.brand_name?.toLowerCase() == 'tesla' &&
            this.renderPane(
              'tesla_additional_info',

              <h1>{this.lbl('interior.inspection.tesla_additional_info')}</h1>,
              <VBox className="import_photo" key="import_photo">
                {this.renderImportPhotos('tesla_additional_info')}

                {this.vehicle.documents
                  ?.filter(document => document.type == 'photo_interior_import')
                  .map(this.renderImportPhoto.bind(this))}
              </VBox>,
            )}

          {this.vehicle?.regplate &&
            this.vehicle?.mileage &&
            this.vehicle.mileage < 3000 &&
            this.renderPane(
              'extra_photos',
              <h1>{this.lbl('interior.inspection.extra_photos_new')}</h1>,
              this.vehicle?.regplate && (
                <VBox className="import_photo" key="import_photo">
                  {this.renderNewPhoto()}

                  {this.vehicle.documents
                    ?.filter(document => document.type === 'photo_interior_general')
                    .map(this.renderImportPhoto.bind(this))}
                </VBox>
              ),
            )}

          {this.renderPane(
            'attention',
            <h1>{this.lbl('interior.inspection.attention_exterior')}</h1>,

            <VBox className="attention" key="attention">
              {this.renderAttentionIncidents('exterior')}
            </VBox>,
          )}
          {this.renderPane(
            'interior_inspection',
            <h1>{this.lbl('interior.inspection.attention_interior')}</h1>,

            <VBox className="attention" key="attention">
              {this.renderAttentionIncidents('interior')}
            </VBox>,
          )}
          {this.renderPane(
            'technical_inspection',
            <h1>{this.lbl('interior.inspection.attention_technical')}</h1>,

            <VBox className="attention" key="attention">
              {this.renderAttentionIncidents('technical')}
            </VBox>,
          )}

          {this.renderPane(
            'import_photo',
            this.vehicle?.vehicle_purpose ? (
              <h1>{this.lbl('interior.inspection.import_photo')}</h1>
            ) : (
              <h1>{this.lbl('interior.inspection.no_vehicle_type')}</h1>
            ),

            this.vehicle?.vehicle_purpose && (
              <VBox className="import_photo" key="import_photo">
                {this.renderImportPhotos()}

                {this.vehicle.documents
                  ?.filter(document => document.type == 'photo_interior_import')
                  .map(this.renderImportPhoto.bind(this))}
              </VBox>
            ),
          )}

          {/* {this.renderPane(
            'impression',
            <h1>{this.lbl('interior.inspection.impression')}</h1>,

            <VBox className="import_photo" key="import_photo">
              {this.renderImpressionPhotos()}
            </VBox>,
          )} */}
          {this.renderPane(
            'general_photo',

            this.lbl('interior.inspection.general_photo'),

            <VBox className="import_photo" key="import_photo">
              {this.renderImportPhotos('generalPhotos')}

              {this.vehicle.documents
                ?.filter(document => document.type == 'photo_interior_general')
                .map(this.renderImportPhoto.bind(this))}
            </VBox>,
          )}
        </VBox>

        <div className={cn('d-flex gap-2 mt-3', { [styles.modalFooter]: window.innerWidth <= 768 })}>
          <div
            onClick={() => {
              if (this.applyDisabled()) {
                alert('De volgende velden zijn niet gevuld:\n- ' + this.missingItems.join('\n- '));
              } else {
                document.getElementById('performActionButton').click();
                this.reset(); // Redirect to /vehicles after the button is clicked
              }
            }}
          >
            {this.state.attentIncidentAdd || this.state.attentIncidentEdit ? (
              <ButtonComponent
                disabled={this.applyDisabled()}
                style={'ButtonSoftEdit'}
                onClick={() => {
                  alert('Er is een niet opgeslagen schade, sla deze eerst op');
                }}
              >
                Akkoord
              </ButtonComponent>
            ) : (
              <PerformActionButton
                className={styles.confirmButton}
                disabled={this.applyDisabled()}
                action={this.props.action}
                target={this.vehicle}
                onChange={this.reset.bind(this)}
              />
            )}
          </div>
          <ButtonComponent style={'ButtonSoftDelete'} onClick={this.reset.bind(this)}>
            {this.lbl('cancel')}
          </ButtonComponent>
        </div>
      </div>
    );
  }

  render() {
    const vehicle = this.vehicle;

    if (!vehicle || !this.props.allOptions) return <Loader small />;

    // if (vehicle?.id != this.props.match.params?.vehicleId) return null;

    return (
      <ActionCell>
        <Container className="modal-inner">{this.renderApprove()}</Container>
      </ActionCell>
    );
  }

  renderImpressionPhotos() {
    const v = this.props.vehicle;

    if (!v) return null;

    if (this.props.workVehicle || this.props.workDoc || this.props.workUpdate) return <Loader small />;

    let defaults = [];
    let rows = [];

    defaults = WS2_1_GENERAL_PHOTOS;

    defaults?.map((type, i) => {
      let photos = v.documents?.filter(d => {
        return d?.type?.indexOf(`photo_interior_import_0 ${type}`) === 0;
      });

      return rows.push({
        index: i,
        placeholder: type,
        photos,
      });
    });

    return (
      <>
        <div key="import_photos" className="grid-container">
          {rows.map(row => {
            return (
              <div key={row?.placeholder}>
                <div className="cell">
                  {row?.photos?.length > 0 ? (
                    <VBox center className="import-photo-wrapper">
                      {row?.photos?.map(doc => this.renderImportPhoto(doc))}
                      <span>{this.lbl(`vehicle.impression_photos.${row?.placeholder}`)}</span>
                    </VBox>
                  ) : (
                    <VBox center className="import-photo-wrapper" onClick={() => this.addImportImage(0, row.placeholder)}>
                      {this.renderPlaceholderImage('passenger', row?.placeholder)}
                      <span>{this.lbl(`vehicle.import_photos.${row?.placeholder}`)}</span>
                    </VBox>
                  )}
                </div>
              </div>
            );
          })}
        </div>
      </>
    );
    return null;
  }

  renderIncidentPhotos(attentionType, index) {
    const v = this.props.vehicle;

    if (!v) return null;

    if (this.props.workVehicle || this.props.workUpdate) return <Loader small />;

    let type = `inspection_incident_${this.state[`inspection_attention_photos_${attentionType}`]}`;

    let photos = v.documents?.filter(d => {
      return d?.type == `photo_interior_${type}`;
    });

    let allPhotos = [...photos, ...this.state.attentionIncidentPhoto];

    return (
      <VBox>
        <br />
        <AddPhotoButton
          onUpload={e => this.capture(type, this.props.refresh, true)}
          key={index}
          disabled={allPhotos?.length > 8}
        />
        <HBox left>
          {allPhotos
            .filter(photo => photo?.url)
            ?.map(({ url, name, id }) => {
              return (
                <div
                  key={url}
                  className="multi-img"
                  style={{ backgroundImage: `url('${url}')` }}
                  onClick={() => {
                    let container = window.document.getElementsByClassName('modal-inner')[0];
                    let renderOptionPhotoDims = container.getBoundingClientRect();
                    renderOptionPhotoDims.height = window.innerHeight;
                    this.setState({
                      renderOptionPhoto: name || id,
                      renderOptionPhotoDims,
                    });
                    if (allPhotos?.length == 1) {
                      this.setState({ disableDeletePhoto: true });
                    } else {
                      this.setState({ disableDeletePhoto: false });
                    }
                  }}
                ></div>
              );
            })}
        </HBox>
      </VBox>
    );
  }

  renderAttentionIncidents(attentionType) {
    const v = this.props.vehicle;
    let type = `inspection_incident_`;
    let key = Object.keys(v || {}).filter(key => key.indexOf('inspection_attention_incident') === 0);
    const index =
      attentionType == 'interior'
        ? 'inspection_attention_incident'
        : attentionType == 'exterior'
        ? 'inspection_attention_exterior_incident'
        : 'inspection_attention_technical_incident';

    const photoIndex =
      attentionType == 'interior'
        ? 'photo_interior_inspection_incident'
        : attentionType == 'exterior'
        ? 'photo_interior_inspection_incident_exterior'
        : 'photo_interior_inspection_incident_technical';

    let partsOptions = [];
    let typesOptions = [];
    let solutionsOptions = [];

    if (attentionType === 'exterior') {
      partsOptions = EXTERIOR_ATTENTION_OPTIONS_IDW.parts;
      typesOptions = EXTERIOR_ATTENTION_OPTIONS_IDW.types;
      solutionsOptions = EXTERIOR_ATTENTION_OPTIONS_IDW.solutions;
    }

    if (attentionType === 'interior') {
      partsOptions = INTERIOR_ATTENTION_OPTIONS_IDW.parts;
      typesOptions = INTERIOR_ATTENTION_OPTIONS_IDW.types;
      solutionsOptions = INTERIOR_ATTENTION_OPTIONS_IDW.solutions;
    }

    if (attentionType === 'technical') {
      partsOptions = TECHNICAL_ATTENTION_OPTIONS_IDW.parts;
      typesOptions = TECHNICAL_ATTENTION_OPTIONS_IDW.types;
      solutionsOptions = TECHNICAL_ATTENTION_OPTIONS_IDW.solutions;
    }

    let parts = partsOptions?.map(part => ({
      value: part,
      label: this.lbl('inspection.attention.part.' + part),
    }));

    let types = typesOptions?.map(type => ({
      value: type,
      label: this.lbl('inspection.attention.type.' + type),
    }));

    let solutions = solutionsOptions?.map(solution => ({
      value: solution,
      label: this.lbl('inspection.attention.solution.' + solution),
    }));

    // let parts = _.times(25, n => ({ value: n + 1, label: this.lbl('inspection.attention.part.' + (n + 1)) }));
    // let types = _.times(10, n => ({ value: n + 1, label: this.lbl('inspection.attention.type.' + (n + 1)) }));
    // let solutions = _.times(8, n => ({ value: n + 1, label: this.lbl('inspection.attention.solution.' + (n + 1)) }));

    if (!v) return;
    if (this.state.currentAttentionType == attentionType && (this.props.workUpdate || this.props.workDoc))
      return <Loader small />;

    if (
      (this.state.attentIncidentAdd || this.state.attentIncidentEdit) &&
      this.state.currentAttentionType == attentionType
    ) {
      return (
        <VBox>
          {attentionType === 'exterior' && (
            <>
              <CarExteriorIncidentsInteractive
                vehicle={this.vehicle}
                onPartClick={part => {
                  this.setState({ selectedAttentionPart: part });
                }}
              />
              {/* <div className={styles.checkboxContainer}>
                <VehiclePropertyLoadable name={'exterior_damage_free'}>
                  <CheckboxComponent
                    label={'damagefree'}
                    checked={this.vehicle?.exterior_damage_free === '1'}
                    onChange={() =>
                      this.vehicle?.exterior_damage_free === '1
                        ? this.props.setProperty('exterior_damage_free', '0')
                        : this.props.setProperty('exterior_damage_free', '1')
                    }
                  />
                </VehiclePropertyLoadable>
              </div> */}
            </>
          )}
          <FormField label={this.lbl('inspection.attention.part')}>
            {attentionType === 'exterior' ? (
              <input className="form-control" disabled value={this.state.selectedAttentionPart} />
            ) : (
              <SearchSelect
                isSearchable={false}
                minWidth={'100%'}
                options={parts}
                value={parts.find(i => i.value == this.state.selectedAttentionPart)}
                onChange={({ value }) => this.setState({ selectedAttentionPart: value })}
              />
            )}
          </FormField>
          {this.state.selectedAttentionPart && (attentionType === 'interior' || attentionType === 'exterior') && (
            <>
              <FormField label={this.lbl('inspection.attention.type')}>
                <SearchSelect
                  isSearchable={false}
                  minWidth={'100%'}
                  options={types}
                  value={types.find(i => i.value == this.state.selectedAttentionType)}
                  onChange={({ value }) => this.setState({ selectedAttentionType: value })}
                />
              </FormField>
            </>
          )}
          <>
            {/* {attentionType === 'interior' ||
              (attentionType === 'exterior' && (
                <FormField label={this.lbl('inspection.attention.solution')}>
                  <SearchSelect
                    isSearchable={false}
                    minWidth={'100%'}
                    options={solutions}
                    value={solutions.find(i => i.value == this.state.selectedAttentionSolution)}
                    onChange={({ value }) => this.setState({ selectedAttentionSolution: value })}
                  />
                </FormField>
              ))} */}
            {this.renderIncidentPhotos(attentionType, index)}
          </>
          {/* )} */}
          {/* {(this.state.selectedAttentionSolution || (attentionType === 'technical' && this.state.selectedAttentionPart)) && ( */}
          {/* <>
            <div>
              <label className="form-label">{this.lbl('inspection.attention.incident.cost')}</label>
              <input
                className="form-control"
                value={this.state.attentionIncidentCost}
                onChange={evt =>
                  this.setState({
                    attentionIncidentCost: evt.target.value.replace(/[^0-9]/g, ''),
                  })
                }
              />
            </div>
            <div>
              <label className="form-label">{this.lbl('inspection.attention.incident.remark')}</label>
              <input
                className="form-control"
                value={this.state.attentionIncidentRemarks}
                onChange={evt =>
                  this.setState({
                    attentionIncidentRemarks: evt.target.value.substr(0, 200),
                  })
                }
              />
            </div>
            <hr />
            {/* {this.lbl('inspection.attention.incident.acceptable')}
            <HBox center gap={12}>
              <Button
                style="ButtonSoftEditFullWidth"
                className={cn(styles.buttonGroupItem, {
                  [styles.selectedButton]: this.state.attentionIncidentAcceptable === true,
                })}
                onClick={this.setStateFn({ attentionIncidentAcceptable: true })}
              >
                {this.lbl('yes')}
              </Button>

              <Button
                className={cn(styles.buttonGroupItem, {
                  [styles.selectedButton]: this.state.attentionIncidentAcceptable === false,
                })}
                onClick={this.setStateFn({ attentionIncidentAcceptable: false })}
              >
                {this.lbl('no')}
              </Button>
            </HBox>{' '}
            {this.lbl('inspection.attention.incident.commercial')}
            <HBox center gap={12}>
              <Button
                style="ButtonSoftEditFullWidth"
                className={cn(styles.buttonGroupItem, {
                  [styles.selectedButton]: this.state.attentionIncidentCommercial === true,
                })}
                onClick={this.setStateFn({ attentionIncidentCommercial: true })}
              >
                {this.lbl('yes')}
              </Button>

              <Button
                className={cn(styles.buttonGroupItem, {
                  [styles.selectedButton]: this.state.attentionIncidentCommercial === false,
                })}
                onClick={this.setStateFn({ attentionIncidentCommercial: false })}
              >
                {this.lbl('no')}
              </Button> */}
          {/* </HBox>{' '} */}
          <HBox center gap={12} style={{ marginTop: '20px' }}>
            {/* <div className={styles.buttonWrapper}> */}

            <ButtonComponent style={'ButtonSoftPrimary'} onClick={() => this.saveIncident(attentionType)}>
              {this.lbl('save')}
            </ButtonComponent>
            {/* </div> */}
            <ButtonComponent
              warning
              onClick={this.setStateFn({
                attentIncidentAdd: false,
                attentIncidentEdit: false,
                inspection_attention_photos_exterior: null,
                inspection_attention_photos_interior: null,
                inspection_attention_photos_technical: null,
                currentAttentionType: null,
                slectedIncidentId: null,
                selectedAttentionPart: null,
                selectedAttentionType: null,
                selectedAttentionSolution: null,
                attentionIncidentCost: '',
                attentionIncidentRemarks: null,
                attentionIncidentRepaired: false,
                attentionIncidentShow: true,
              })}
            >
              {this.lbl('cancel')}
            </ButtonComponent>
          </HBox>{' '}
        </VBox>
      );
    } else {
      return (
        <VBox>
          {Object.keys(v || {})
            .filter(key => key.indexOf('inspection_attention_incident') === 0)

            .map(key => {
              let incidentProp = typeof v[key] == 'string' ? JSON.parse(v[key]) : v[key];

              if (v[key]?.attentionType != attentionType) return;

              return (
                <HBox key={key} vCenter>
                  <div>
                    {/* {key}&nbsp; */}
                    {incidentProp?.part ? this.lbl('inspection.attention.part.' + incidentProp?.part) : ''}&nbsp;:&nbsp;
                    {incidentProp?.type ? this.lbl('inspection.attention.type.' + incidentProp?.type) : ''}
                  </div>
                  <div className={styles.containerButtonBar}>
                    <ButtonBar>
                      {/* <Button
                        // style="ButtonSoftPrimary"
                        className={styles.buttonBarItem}
                        small
                        size={'btn-sm'}
                        onClick={this.setStateFn({
                          [`inspection_attention_photos_${attentionType}`]: incidentProp?.id || null,
                          // currentAttentionType: attentionType,
                          [attentionType]: attentionType,
                        })}
                      >
                        <Camera />
                      </Button> */}
                      <Button
                        className={styles.buttonBarItem}
                        small
                        onClick={this.setStateFn({
                          currentAttentionType: attentionType,
                          [`inspection_attention_photos_${attentionType}`]: incidentProp?.id || null,
                          // currentAttentionType: attentionType,
                          [attentionType]: attentionType,
                          slectedIncidentId: incidentProp?.id,
                          attentIncidentEdit: true,
                          selectedAttentionPart: incidentProp?.part || '',
                          selectedAttentionType: incidentProp?.type || '',
                          selectedAttentionSolution: incidentProp?.solution || '',
                          attentionIncidentCost: incidentProp?.cost?.replace(/[^0-9]/g, ''),
                          attentionIncidentRemarks: incidentProp?.remarks,
                        })}
                      >
                        <EditSquare />
                      </Button>
                      <Button
                        className={styles.buttonBarItem}
                        small
                        onClick={() => (confirm('delete?') ? this.props.deleteProperty(key) : null)}
                      >
                        x
                      </Button>
                    </ButtonBar>
                  </div>
                </HBox>
              );
            })}

          <Button
            onClick={this.setStateFn({
              attentIncidentAdd: true,
              currentAttentionType: attentionType,
              attentionIncidentPhoto: [],
            })}
          >
            +&nbsp;{this.lbl('add')}
          </Button>
        </VBox>
      );
    }
  }

  saveIncident(attentionType) {
    const v = this.props.vehicle;

    const isTechnicalWithoutOtherPart = attentionType === 'technical';

    // if (!this.state.attentionIncidentPhoto?.length && !isTechnicalWithoutOtherPart) {
    //   alert('Fout bij het uploaden van de foto. Maak foto opnieuw of voeg toe');
    //   return; // Stop execution if no photos are uploaded and the conditions are met
    // }

    // Enforce that remarks must be provided if part or type is "anders"
    // if (
    //   (this.state.selectedAttentionPart === 'anders' || this.state.selectedAttentionType === 'anders') &&
    //   !this.state.attentionIncidentRemarks
    // ) {
    //   alert('Opmerking is verplicht wanneer onderdeel of type "anders" is geselecteerd.');
    //   return; // Stop execution if no remarks are provided for "anders" part or type
    // }

    if (attentionType !== this.state.currentAttentionType) return;
    const index =
      attentionType == 'interior'
        ? 'inspection_attention_incident'
        : attentionType == 'exterior'
        ? 'inspection_attention_exterior_incident'
        : 'inspection_attention_technical_incident';

    let id =
      Object.keys(v)
        .filter(key => key.indexOf('inspection_attention_incident') === 0)
        .map(key => parseInt(key.split('_').pop(), 10))
        .sort((a, b) => a - b)
        .pop() || 0;

    ++id;

    if (this.state.attentIncidentEdit) {
      id = this.state.slectedIncidentId;
    }

    let incident = {
      id,
      part: this.state.selectedAttentionPart,
      type: this.state.selectedAttentionType,
      solution: this.state.selectedAttentionSolution,
      cost: this.state.attentionIncidentCost,
      remarks: this.state.attentionIncidentRemarks,
      show: this.state.attentionIncidentShow,
      repaired: this.state.attentionIncidentRepaired,
      attentionType: attentionType,
    };

    this.props.setProperty('inspection_attention_incident_' + id, JSON.stringify(incident), () => {
      if (this.state.attentionIncidentPhoto?.length) {
        this.props.multiImagesUpload(this.multiPhotosDto(id), 'upload_' + `inspection_incident_${id}`, () => {
          this.setState({
            attentIncidentAdd: false,
            attentIncidentEdit: false,
            currentAttentionType: null,
            slectedIncidentId: null,
            selectedAttentionPart: null,
            selectedAttentionType: null,
            selectedAttentionSolution: null,
            attentionIncidentCost: '',
            attentionIncidentRemarks: null,
            attentionIncidentAcceptable: null,
            attentionIncidentRepaired: false,
            attentionIncidentShow: true,
            attentionIncidentPhoto: [],
            inspection_attention_photos_exterior: null,
            inspection_attention_photos_interior: null,
            inspection_attention_photos_technical: null,
          });
        });
      }
      this.setState({
        attentIncidentAdd: false,
        attentIncidentEdit: false,
        currentAttentionType: null,
        slectedIncidentId: null,
        selectedAttentionPart: null,
        selectedAttentionType: null,
        selectedAttentionSolution: null,
        attentionIncidentCost: '',
        attentionIncidentRemarks: null,
        attentionIncidentAcceptable: null,
        attentionIncidentRepaired: false,
        attentionIncidentShow: true,
        attentionIncidentPhoto: [],
        inspection_attention_photos_exterior: null,
        inspection_attention_photos_interior: null,
        inspection_attention_photos_technical: null,
      });

      //update total amount
      let costs = Object.keys(v)
        .filter(key => key.indexOf('inspection_attention_incident') === 0)
        .map(key => parseInt(v[key]?.cost, 10) || 0);

      this.props.setProperty('inspection_attention_damage_cost_sum', _.sum(costs));
    });
  }
}

Interior_inspection_mobile_pageComp.propTypes = {
  dispatch: PropTypes.func.isRequired,
};

const mapStateToProps = (state, ownProps) =>
  createStructuredSelector({
    allOptions: selectAllOptions(),
    vehicle: selectVehicle(ownProps.vehicleId),
    workUpdate: selectWork(REQUEST_VEHICLE_PROPERTY_UPDATE),
    workVehicle: selectWork(REQUEST_VEHICLE),
    workDoc: selectWorks([REQUEST_ADD_DOCUMENT, REQUEST_ADD_MULTIPLE_DOCUMENTS, REQUEST_DELETE_DOCUMENT]),
    workLocation: selectWork(SET_VEHICLE_LOCATION),
    loading: selectWorks([REQUEST_VEHICLE_PROPERTY_UPDATE + '-' + 'location_company_id', 'location_company_id']),
    loggedInUser: selectUser(ownProps.loggedInUserId),
  });

function mapDispatchToProps(dispatch, ownProps) {
  return {
    dispatch,
    confirm(vehicle_id, regplate_code) {
      dispatch(performAction(ownProps.action.id, vehicle_id, { regplate_code }));
    },
    refresh() {
      dispatch(fetchVehicle(ownProps.vehicleId));
    },
    toggleOption(optionId, state, callback) {
      let fn = state ? addVehicleOption : removeVehicleOption;
      dispatch(fn(ownProps.vehicleId, optionId, callback));
    },
    setProperty(name, value, callback) {
      dispatch(setVehicleProperty(ownProps.vehicleId, name, value, callback));
    },
    imageUpload(documentDto, work, callback) {
      dispatch(addDocument(ownProps.vehicleId, 'vehicle', documentDto, callback, work));
    },
    multiImagesUpload(documentsDto, work, callback) {
      dispatch(addMultipleDocs(ownProps.vehicleId, 'vehicle', documentsDto, callback, work));
    },
    deleteDocument(id, callback) {
      dispatch(deleteDocument(ownProps.vehicleId, 'vehicle', id, callback));
    },
    deleteProperty(name, callback) {
      dispatch(deleteVehicleProperty(ownProps.vehicleId, name, callback));
    },
  };
}

const withConnect = connect(mapStateToProps, mapDispatchToProps);

export const Interior_inspection_mobile_page = compose(withConnect, withRouter)(Interior_inspection_mobile_pageComp);
